// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Ufiq","content":"styles_content__2p21x","selectAll":"styles_selectAll__1W1ff"};